import { Controller } from "@hotwired/stimulus"

// Material Design ripple effect
// Usage: data-controller="ripple" data-action="click->ripple#create"
export default class extends Controller {
  static values = {
    color: { type: String, default: "rgba(255, 255, 255, 0.5)" },
    duration: { type: Number, default: 600 }
  }

  connect() {
    // Ensure element has relative positioning
    const position = window.getComputedStyle(this.element).position
    if (position === "static") {
      this.element.style.position = "relative"
    }

    // Only apply overflow: hidden if element doesn't explicitly set overflow-visible
    // This allows tabs and other components to show content outside bounds (e.g., indicator dots)
    const hasOverflowVisible = this.element.classList.contains('overflow-visible')
    if (!hasOverflowVisible) {
      this.element.style.overflow = "hidden"
    }
  }

  create(event) {
    // Remove existing ripples
    const existingRipples = this.element.querySelectorAll('.ripple-effect')
    existingRipples.forEach(ripple => ripple.remove())

    // Create ripple element
    const ripple = document.createElement('span')
    ripple.classList.add('ripple-effect')

    // Calculate ripple size and position
    const rect = this.element.getBoundingClientRect()
    const size = Math.max(rect.width, rect.height)
    const x = event.clientX - rect.left - size / 2
    const y = event.clientY - rect.top - size / 2

    // Apply styles
    Object.assign(ripple.style, {
      position: 'absolute',
      width: `${size}px`,
      height: `${size}px`,
      left: `${x}px`,
      top: `${y}px`,
      borderRadius: '50%',
      backgroundColor: this.colorValue,
      pointerEvents: 'none',
      transform: 'scale(0)',
      opacity: '1',
      transition: `transform ${this.durationValue}ms ease-out, opacity ${this.durationValue}ms ease-out`
    })

    // Add to element
    this.element.appendChild(ripple)

    // Trigger animation
    requestAnimationFrame(() => {
      ripple.style.transform = 'scale(2)'
      ripple.style.opacity = '0'
    })

    // Remove ripple after animation completes
    setTimeout(() => {
      ripple.remove()
    }, this.durationValue)
  }
}
